import PaidIcon from "@mui/icons-material/Paid";
import StyleIcon from "@mui/icons-material/Style";
import * as Yup from "yup";

// Payment modes the drawer can be in. ONLINE and CASH are the two tabs; BANK is
// only reachable when a caller preselects it.
export const PAYMENT_MODE = {
  ONLINE: "ONLINE",
  CASH: "CASH",
  BANK: "BANK",
} as const;

export const PAYMENT_OPTIONS = [
  {
    value: "ONLINE",
    label: "Card Payment",
    icon: <StyleIcon />,
  },
  {
    value: "CASH",
    label: "Cash Payment",
    icon: <PaidIcon />,
  },
];

export const BANK_OPTIONS = [
  {
    value: "CHEQUE",
    label: "Cheque / NEFT",
  },
  {
    value: "RTGS",
    label: "RTGS",
  },
];

// Shared by Add Card, Edit Card, Collect Payment and Scheduling. trim() runs
// first, so a whitespace-only value is rejected as blank; the pattern then
// requires at least one letter, rejecting digit- or symbol-only input.
export const CARD_HOLDER_NAME_SCHEMA = Yup.string()
  .trim()
  .required("Card Holder Name is a required field.")
  .matches(/[a-zA-Z]/, "Please enter a valid Cardholder Name.");

// Collect Payment -> Cash: the transaction Date is mandatory and defaults to
// the current date.
export const PAYMENT_DATE_REQUIRED_MSG = "Date is a required field.";
